module.exports = __webpack_public_path__ + "assets/static/media/hireprivy_splash_screen_1.4e80509f.png";